(function() {
    'use strict';
    angular
        .module('MW.Framework.Editor.v4', [
            'MW.Framework.CoreCompanyService',
            'Configuration',
            'MW.Framework.CoreUserService',
            'MW.Framework.TranslationService',
            'MW.Influencers.IcmDialogService'
        ])
        .directive('tinymceEditorV4', [
            '$timeout',
            'CoreCompanyService',
            'CoreUserService',
            'translationService',
            'DialogService',
            'FILE_UPLOADER_URL',
            'ICM_ASSETS_URL',
            '$parse',
            function ($timeout,
                      CoreCompanyService,
                      CoreUserService,
                      translationService,
                      DialogService,
                      FILE_UPLOADER_URL,
                      ICM_ASSETS_URL,
                      $parse
            ) {
                var randomEditorId = Math.ceil(Math.random() * 10000);

                return {
                    restrict: 'A',
                    require: 'ngModel',
                    link: function(scope, elem, attrs, ngModel) {
                        translationService.waitForTranslations().then(function() {
                            var options, customOptions, editorInstance, updateView, setElementAttributes, createFormats, imageUploadHandlerFn,
                                imageUploadAcceptedTypes = 'image/jpeg, image/jpg, image/png, image/gif, image/svg+xml',
                                smallStr = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--font-size-small'),
                                normalStr = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--font-size-normal'),
                                largeStr = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--font-size-large'),
                                hugeStr = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--font-size-huge'),
                                fixedStr = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--font-family-fixed'),
                                wideStr = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--font-family-wide'),
                                narrowStr = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--font-family-narrow'),
                                listTooltip = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--list-tooltip'),
                                bullistTooltip = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--bullist-tooltip'),
                                numlistTooltip = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--numlist-tooltip'),
                                indentTooltip = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--indent-tooltip'),
                                firstNameText = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--first-name'),
                                firstNamePlaceholder = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--first-name-placeholder'),
                                lastNameText = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--last-name'),
                                lastNamePlaceholder = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--last-name-placeholder'),
                                genericErrorMessage = translationService.getLocalizedString('Something has gone wrong behind the scenes. Please try again later.'),
                                uploadingImageMessage = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--uploading-image-message'),
                                editorLanguageMap = {
                                    da: 'da',     // danish
                                    de: 'de',     // german
                                    en: null,  // english (default)
                                    es: 'es',     // spanish
                                    fi: 'fi',     // finnish
                                    fr: 'fr_FR',  // french
                                    ja: 'ja',     // japanese
                                    nb: 'nb_NO',  // norwegian
                                    nl: 'nl',     // dutch
                                    pt: 'pt_PT',  // portuguese
                                    sv: 'sv_SE',  // swedish
                                    /* jshint camelcase: false */
                                    zh_CN: 'zh_CN',   // chinese (simplified)
                                    /* jshint camelcase: false */
                                    zh_TW: 'zh_TW'    // chinese (traditional)
                                },
                                editorLanguage = editorLanguageMap.hasOwnProperty(CoreUserService.getLanguage()) ? editorLanguageMap[CoreUserService.getLanguage()] : null;

                            //we're now using this Handler for powerPaste and custom imageUpload
                            imageUploadHandlerFn = function imagesUploadHandler(blobInfo, success, failure) {
                                var xhr, formData;
                                xhr = new XMLHttpRequest();
                                xhr.open('POST', FILE_UPLOADER_URL + '/upload');
                                xhr.withCredentials = false;
                                xhr.timeout = 10000; //TODO: move this out to configuration, if we do it now though, won't be able to patch in december

                                function setIsBusy(isBusy) {
                                    var callbackFunction;

                                    if (attrs.busyCallback) {
                                        callbackFunction = $parse(attrs.busyCallback);
                                        callbackFunction(scope, {isBusy: isBusy});
                                    }
                                }

                                // on start of upload, we are busy
                                setIsBusy(true);

                                function failed(message) {
                                    setIsBusy(false);
                                    failure(message);
                                }

                                function succeeded(link) {
                                    setIsBusy(false);
                                    success(link);
                                    updateView();
                                }

                                xhr.onload = function() {
                                    var json;

                                    if (xhr.status !== 200) {
                                        failed('HTTP Error: ' + xhr.status);
                                        return;
                                    }
                                    json = JSON.parse(xhr.responseText);

                                    if (!json || typeof json.link !== 'string') {
                                        failed('Invalid JSON: ' + xhr.responseText);
                                        return;
                                    }
                                    succeeded(json.link);
                                };
                                xhr.ontimeout = function() {
                                    failed('HTTP Error: ' + xhr.status);
                                };
                                formData = new FormData();
                                formData.append('file', blobInfo.blob(), blobInfo.filename());
                                formData.append('renameFileWithTimestamp', true);
                                xhr.setRequestHeader('Authorization', CoreCompanyService.getAuthToken());
                                xhr.send(formData);
                            };

                            // assign/replace ID
                            attrs.$set('id', 'editor_' + randomEditorId);

                            // customOptions passed as directive parameters
                            if (attrs.tinymceEditorOptions) {
                                customOptions = scope.$eval(attrs.tinymceEditorOptions);
                            } else {
                                customOptions = {};
                            }
                            options = {
                                // Update model after user actions
                                setup: function (editor) {
                                    editor.on('init', function () {
                                        ngModel.$render();

                                        // register method to be called on blur event
                                        if (customOptions.onBlurEvent && customOptions.context) {
                                            editor.on('blur', customOptions.onBlurEvent.bind(customOptions.context));
                                        }
                                    });

                                    // Update model on button click, keypress, blur
                                    editor.on('ExecCommand KeyUp blur', function () {
                                        editor.save();
                                        updateView();
                                    });
                                    // Update model on change, i.e. copy/pasted text, plugins altering content
                                    editor.on('SetContent', function (e) {
                                        if (!e.initial) {
                                            editor.save();
                                            updateView();
                                        }
                                    });
                                    // action when Image resized
                                    editor.on('ObjectResized', function(e) {
                                        if (e.target.nodeName === 'IMG') {
                                            $timeout($(e.target).removeAttr('data-mce-style').removeAttr('style'), 0);
                                        }
                                    });

                                    //icm_fontFamilyList button
                                    editor.addButton('icm_fontFamilyList', function() {
                                        var emailSupportedFontFamilies =
                                                'Sans Serif=arial,helvetica,sans-serif;' +
                                                'Serif=times new roman,serif;' +
                                                fixedStr + '=monospace,monospace;' +
                                                wideStr + '=arial black,sans-serif;' +
                                                narrowStr + '=arial narrow,sans-serif;' +
                                                'Comic Sans MS=comic sans ms,sans-serif;' +
                                                'Garamond=garamond,serif;' +
                                                'Georgia=georgia,serif;' +
                                                'Tahoma=tahoma,sans-serif;' +
                                                'Trebuchet MS=trebuchet ms,sans-serif;' +
                                                'Verdana=verdana,sans-serif;',
                                            items = [],
                                            fonts = createFormats(editor.settings.font_formats || emailSupportedFontFamilies); // jshint ignore:line

                                        angular.forEach(fonts, function(font) {
                                            items.push({
                                                text: {raw: font[0]},
                                                value: font[1],
                                                textStyle: 'font-family:' + font[1]
                                            });
                                        });

                                        return {
                                            type: 'listbox',
                                            text: '',
                                            tooltip: 'Font Family',
                                            values: items,
                                            fixedWidth: true,
                                            onselect: function onSelectFontFn(e) {
                                                var newValue = (e.control.settings.value) ? e.control.settings.value : false,
                                                    currentValue = editor.queryCommandValue('FontName');
                                                if (newValue && ((currentValue === 0) || (newValue !== currentValue))) {
                                                    editor.execCommand('FontName', false, newValue);
                                                } else {
                                                    editor.focus();
                                                }
                                            }
                                        };
                                    });

                                    //icm_fontSizeList button
                                    editor.addButton('icm_fontSizeList', function() {
                                        var emailSupportedFontSizes =
                                                smallStr + '=10px;' +
                                                normalStr + '=13px;' +
                                                largeStr + '=18px;' +
                                                hugeStr + '=32px;',
                                            items = [],
                                            sizes = createFormats(editor.settings.fontsize_formats || emailSupportedFontSizes); // jshint ignore:line

                                        angular.forEach(sizes, function(size) {
                                            items.push({
                                                text: {raw: size[0]},
                                                value: size[1],
                                                textStyle: 'font-size:' + size[1]
                                            });
                                        });

                                        return {
                                            type: 'listbox',
                                            text: '',
                                            tooltip: 'Font Sizes',
                                            values: items,
                                            fixedWidth: true,
                                            onselect: function(e) {
                                                var newValue = (e.control.settings.value) ? e.control.settings.value : false,
                                                    currentValue = editor.queryCommandValue('FontSize');
                                                if (newValue && ((currentValue === 0) || (newValue !== currentValue))) {
                                                    editor.execCommand('FontSize', false, newValue);
                                                } else {
                                                    editor.focus();
                                                }
                                            },
                                            onPostRender: function () {
                                                // select NORMAL by default
                                                this.value(items[1].value);
                                            }
                                        };
                                    });

                                    editor.addButton('icm_bullist', {
                                        icon: 'bullist',
                                        text: '',
                                        tooltip: bullistTooltip,
                                        onclick: function bulletListFn() {
                                            tinymce.execCommand('InsertUnorderedList');
                                        }
                                    });

                                    editor.addButton('icm_numlist', {
                                        icon: 'numlist',
                                        text: '',
                                        tooltip: numlistTooltip,
                                        onclick: function orderedListFn() {
                                            tinymce.execCommand('InsertOrderedList');
                                        }
                                    });

                                    //icm_alignmentList button
                                    editor.addButton('icm_alignmentList', {
                                        type: 'menubutton',
                                        text: '',
                                        icon: 'alignleft',
                                        tooltip: 'Alignment',
                                        menu: [{
                                            icon: 'alignleft',
                                            text: 'Left',
                                            onclick: function alignLeftFn() {
                                                tinymce.execCommand('JustifyLeft');
                                                setElementAttributes(this.parent().parent(), null, 'alignleft', 'JustifyLeft');
                                            }
                                        }, {
                                            icon: 'alignright',
                                            text: 'Right',
                                            onclick: function alignRightFn() {
                                                tinymce.execCommand('JustifyRight');
                                                setElementAttributes(this.parent().parent(), null, 'alignright', 'JustifyRight');
                                            }
                                        }, {
                                            icon: 'aligncenter',
                                            text: 'Center',
                                            onclick: function alignCenterFn() {
                                                tinymce.execCommand('JustifyCenter');
                                                setElementAttributes(this.parent().parent(), null, 'aligncenter', 'JustifyCenter');
                                            }
                                        }, {
                                            icon: 'alignjustify',
                                            text: 'Justify',
                                            onclick: function alignJustifyFn() {
                                                tinymce.execCommand('JustifyFull');
                                                setElementAttributes(this.parent().parent(), null, 'alignjustify', 'JustifyFull');
                                            }
                                        }],
                                        onPostRender: function onPostRenderAlignmentFn() {
                                            // initial value
                                            this.value = 'JustifyLeft';
                                        }
                                    });

                                    //icm_list button
                                    editor.addButton('icm_list', {
                                        type: 'menubutton',
                                        text: '',
                                        tooltip: listTooltip,
                                        icon: 'bullist',
                                        menu: [{
                                            icon: 'bullist',
                                            text: 'Bullet list',
                                            onclick: function bulletListFn() {
                                                tinymce.execCommand('InsertUnorderedList');
                                            }
                                        }, {
                                            icon: 'numlist',
                                            text: 'Numbered list',
                                            onclick: function orderedListFn() {
                                                tinymce.execCommand('InsertOrderedList');
                                            }
                                        }],
                                        onPostRender: function onPostRenderListFn() {
                                            // initial value
                                            this.value = 'InsertUnorderedList';
                                        }
                                    });

                                    //icm_indentation button
                                    editor.addButton('icm_indentation', {
                                        type: 'menubutton',
                                        text: '',
                                        icon: 'outdent',
                                        tooltip: indentTooltip,
                                        fixedWidth: false,
                                        menu: [{
                                            icon: 'outdent',
                                            text: 'Decrease indent',
                                            onclick: function outdentFn() {
                                                tinymce.execCommand('Outdent');
                                            }
                                        }, {
                                            icon: 'indent',
                                            text: 'Increase indent',
                                            onclick: function indentFn() {
                                                tinymce.execCommand('Indent');
                                            }
                                        }],
                                        onPostRender: function onPostRenderIndentationFn() {
                                            // initial value
                                            this.value = 'Outdent';
                                        }
                                    });

                                    //icm_mailMerge button
                                    editor.addButton('icm_mailMerge', {
                                        type: 'menubutton',
                                        text: '',
                                        icon: 'person',
                                        menu: [{
                                            icon: '',
                                            text: firstNameText,
                                            onclick: function firstNameFn() {
                                                editor.insertContent('<span class="mceNonEditable">' + firstNamePlaceholder + '</span>');
                                            }
                                        }, {
                                            icon: '',
                                            text: lastNameText,
                                            onclick: function lastNameFn() {
                                                editor.insertContent('<span class="mceNonEditable">' + lastNamePlaceholder + '</span>');
                                            }
                                        }]
                                    });

                                    //icm_insertImage
                                    editor.addButton('icm_imageUpload', function() {
                                        var inputFileId = 'file_' + randomEditorId;

                                        return {
                                            icon: 'image',
                                            tooltip: 'Insert Image',
                                            onPostRender: function () {
                                                //add a form to document.body with a single file input in it
                                                angular.element(document.body)
                                                    .append(
                                                        angular.element('<form/>')
                                                            .append(
                                                                angular.element('<input/>')
                                                                    .attr('type', 'file')
                                                                    .attr('name', inputFileId)
                                                                    .attr('accept', imageUploadAcceptedTypes)
                                                                    .attr('id', inputFileId)
                                                                    .attr('style', 'display: none;') // this was adding a visible file selector on the page
                                                            )
                                                    );

                                                angular.element('#' + inputFileId).on('change', function () {
                                                    if(angular.element(this).val().length > 0) {
                                                        var imageBlob, blobInfo, blobObjectUrl, image,
                                                            imageId = 'image_' + Math.ceil(Math.random() * 10000 + 1),
                                                            file = $('#' + inputFileId)[0].files[0],
                                                            fileReader = new FileReader();

                                                        // use the fileReader to upload a blob and attach the img element to tinyMCE
                                                        fileReader.onloadend = function whenFileReaderIsReady(event) {
                                                            imageBlob = new Blob([event.target.result], {type : file.type});
                                                            blobObjectUrl = window.URL.createObjectURL(imageBlob);

                                                            //let's use the blobObjectURL as src temporarily while we upload our image to S3, we'll then replace it with the actual URL
                                                            image = new Image();
                                                            image.addEventListener('load', function() {
                                                                editor.insertContent(
                                                                    angular.element('<img />')
                                                                        .attr('id', imageId)
                                                                        .attr('width', image.width)
                                                                        .attr('height', image.height)
                                                                        .attr('style', 'opacity: 0.3;')
                                                                        .attr('src', image.src)[0].outerHTML
                                                                );
                                                                editor.insertContent('<p></p>'); //breakline after inserting image
                                                                image = null;
                                                            }, false);
                                                            image.src = blobObjectUrl;

                                                            //reset the input file for further use
                                                            angular.element('#' + inputFileId)
                                                                .parent()
                                                                .get(0)
                                                                .reset();

                                                            //object used by our handler
                                                            blobInfo = {
                                                                blob: function blob() {
                                                                    return imageBlob;
                                                                },
                                                                filename: function filename() {
                                                                    return file.name;
                                                                }
                                                            };

                                                            // //set a loading state right after loading image so the user knows there is something going on!
                                                            editor.notificationManager.open({
                                                                text: uploadingImageMessage,
                                                                type: 'info',
                                                                timeout: -1,
                                                                progressBar: false
                                                            });

                                                            //use imageUploadHandlerFn to upload our file
                                                            imageUploadHandlerFn(blobInfo, function success(link) {

                                                                //now let's make a new image to replace scr and remove upload notification once loaded
                                                                image = new Image();
                                                                image.addEventListener('load', function() {
                                                                    editor.$('#' + imageId)
                                                                        .attr('src', link)
                                                                        .removeAttr('style')
                                                                        .removeAttr('id');

                                                                    editor.notificationManager.close();
                                                                    image = null;

                                                                }, false);

                                                                image.src = link;
                                                            }, function failure() {
                                                                //if the upload fails, lets get rid of the image, close notification and display our flash error
                                                                editor.$('#' + imageId).remove();
                                                                editor.notificationManager.close();
                                                                DialogService.flashError(genericErrorMessage);

                                                                $timeout(function() {
                                                                    angular.element(document.body).triggerHandler('click');
                                                                });
                                                            });

                                                        };

                                                        fileReader.readAsArrayBuffer(file);
                                                    }

                                                });

                                            },
                                            onclick: function () {
                                                angular.element('#' + inputFileId).click();
                                            }
                                        };
                                    });

                                    if (customOptions.setup) {
                                        scope.$eval(customOptions.setup);
                                        delete customOptions.setup;
                                    }
                                },
                                skin: 'meltwater',
                                base: ICM_ASSETS_URL +'client/js/lib/tinymce_v4',
                                menubar: false,
                                statusbar: false,
                                mode: 'exact',
                                elements: attrs.id,
                                plugins: 'powerpaste',
                                language: editorLanguage,
                                /* jshint camelcase: false */
                                entity_encoding: 'raw',
                                // Uploads a file to our node-file-uploader and returns the link
                                /* jshint camelcase: false */
                                font_formats: 'Sans Serif=arial,helvetica,sans-serif;Serif=times new roman,serif;' + fixedStr + '=monospace,monospace;' + wideStr + '=arial black,sans-serif;' + narrowStr + '=arial narrow,sans-serif;Comic Sans MS=comic sans ms,sans-serif;Garamond=garamond,serif;Georgia=georgia,serif;Tahoma=tahoma,sans-serif;Trebuchet MS=trebuchet ms,sans-serif;Verdana=verdana,sans-serif;',
                                images_upload_handler: imageUploadHandlerFn,
                                //force_br_newlines : false,
                                force_p_newlines : false,
                                forced_root_block : '',
                                /* jshint camelcase: false */
                                init_instance_callback: function(editor) {
                                    if(attrs.stickTo) {
                                        var editorContainerElement = angular.element(editor.editorContainer),
                                            toolbarElement = editorContainerElement.find('.mce-toolbar-grp'),
                                            editAreaElement = editorContainerElement.find('.mce-edit-area'),
                                            stickToElement = angular.element(attrs.stickTo),
                                            debounceScroll = _.debounce(function() {
                                                if(editorContainerElement.position().top <= 0) {
                                                    toolbarElement.css('top', stickToElement.offset().top);

                                                    toolbarElement.addClass('stick');
                                                    editAreaElement.addClass('stick');
                                                } else {
                                                    toolbarElement.removeClass('stick');
                                                    editAreaElement.removeClass('stick');
                                                }

                                                repositionColorPicker();
                                            }, 10),
                                            // fix the issue with color picker going off screen when header is stuck
                                            repositionColorPicker = function repositionColorPicker() {
                                                var colorButton = document.querySelector('.mce-colorbutton');
                                                if(colorButton) {
                                                    $('.mce-colorbutton-grid').closest('div').css('top', ($('.mce-colorbutton').offset() + $('.mce-colorbutton').height()));
                                                }
                                            };

                                        stickToElement.on('scroll', debounceScroll);

                                        // choosing the color picker propagates up to the textEditor. was getting messy trying to trap the event in between, so just handle it here.
                                        $('.textEditor').on('click', function() {
                                            repositionColorPicker();
                                        });
                                    }

                                    //set focus on first input
                                    $('form *:input[type!=hidden][type!=file]:first').focus();

                                }
                            };

                            var newPlugins = options.plugins + ' ' + customOptions.plugins;
                            angular.extend(options, customOptions);

                            if(customOptions.plugins) {
                                options.plugins = newPlugins;
                            }

                            options.invalid_styles = 'visibility overflow opacity';

                            function initTiny() {
                                $timeout(function initializeEditor() {
                                    if(window.tinymce) {
                                        window.tinymce.init(options);
                                        editorInstance = window.tinymce.get(attrs.id);
                                    } else {
                                        initTiny();
                                    }
                                }, 100);
                            }
                            initTiny();

                            ngModel.$render = function () {	
                                if(editorInstance && editorInstance.getDoc() && ngModel) {	
                                    editorInstance.setContent(ngModel.$viewValue || '');	
                                }	
                            };

                            scope.$on('$destroy', function() {
                                if(editorInstance) {
                                    editorInstance.remove();
                                }

                                if(attrs.stickTo) {
                                    angular.element(attrs.stickTo).off('scroll');
                                }

                                $('.textEditor').off('click');
                            });

                            updateView = function updateView() {
                                ngModel.$setViewValue(editorInstance.getContent());

                                $timeout(function applyChanges() {
                                    scope.$apply();
                                }, 0);
                            };

                            setElementAttributes = function setElementAttributes(el, text, icon, value) {
                                if (text) {
                                    el.text(text);
                                }

                                if(icon) {
                                    el.icon(icon);
                                }

                                if(value) {
                                    el.value = value;
                                }
                            };

                            createFormats = function createFormats(formats) {
                                formats = formats.replace(/;$/, '').split(';');

                                var i = formats.length;
                                while (i--) {
                                    formats[i] = formats[i].split('=');
                                }

                                return formats;
                            };
                        });
                    }
                };
            }]);
}());
